import { Button } from "@material-ui/core";
import { HistoryOutlined, VideocamOutlined } from "@material-ui/icons";
import Alert from "@material-ui/lab/Alert";
import clsx from "clsx";
import { Link as LinkRouter } from "react-router-dom";

import { useStyles } from "@/common/components/MapLandingPage/RightUnitDrawer/DrawerNavigationButtonsStyles";
import { useSelector } from "@/store";
import { mapSelectors } from "@/store/map/slice";
import * as FullStory from "@/utilities/hooks/fullstory";


interface DrawerNavigationButtonProps {
    accessHistory: boolean;
    accessStream: boolean | null;
    hasCameras: boolean | null;
    defaultCameraId: number | null;
}

const DrawerNavigationButtons: React.FC<DrawerNavigationButtonProps> = ({
    defaultCameraId,
    hasCameras,
    accessStream,
    accessHistory,
}) => {
    const selectedUnitId = useSelector(mapSelectors.getSelectedUnitId);
    const isArchiveCabinet = useSelector(mapSelectors.getIsArchiveCabinet);
    const isDeactivated = useSelector(mapSelectors.getIsDeactivated);

    const classes = useStyles();

    const streamUrl = `/camera/${defaultCameraId}/stream`;

    const archiveUrl =
        isArchiveCabinet
            ? `/archive-cabinet/${selectedUnitId}/history`
            : `/live-unit/${selectedUnitId}/history`;

    let warning: string | null = null;

    if (hasCameras === false) {
        warning = "This live unit does not have any cameras.";
    } else if (accessStream === false && !accessHistory) {
        warning = "You don't have access to the Streaming or the History page.";
    } else if (accessStream === false) {
        warning = "You don't have access to the Streaming page.";
    } else if (!accessHistory) {
        warning = "You don't have access to the History page.";
    }

    return (
        <div className={classes.buttonGroup}>
            {!isArchiveCabinet && !isDeactivated && defaultCameraId && (
                <LinkRouter
                    to={streamUrl}
                    style={accessStream ? {} : { pointerEvents: "none" }}
                >
                    <Button
                        disabled={!accessStream}
                        variant="outlined"
                        className={clsx(classes.button, FullStory.names.classes.searchDrawer.streamButton)}
                        startIcon={<VideocamOutlined fontSize="medium" />}
                        fullWidth={true}
                    >
                        Stream
                    </Button>
                </LinkRouter>
            )}

            <LinkRouter
                to={archiveUrl}
                style={accessHistory ? {} : { pointerEvents: "none" }}
            >
                <Button
                    disabled={!accessHistory}
                    variant="outlined"
                    className={clsx(classes.button, FullStory.names.classes.searchDrawer.historyButton)}
                    startIcon={<HistoryOutlined fontSize="medium" />}
                    fullWidth={true}
                >
                    History
                </Button>
            </LinkRouter>
            {/* <LinkRouter to="" className={classes.linkDecoration}>
            <Button
            variant="outlined"
            className={classes.button}
            startIcon={<NotificationsActiveOutlined fontSize="medium" />}
            fullWidth={true}
            >
            Events
            </Button>
        </LinkRouter> */}
            {warning && <Alert severity="warning">{warning}</Alert>}
        </div>
    );
};

export default DrawerNavigationButtons;
